import { GlobeOutline, OfficeBuildingOutline, UserGroupOutline } from '@bonusly/design-system';

import { SavedFilterOption } from '../components/BonusFeed/hooks/useSavedFilterOptions';
import { FeedType } from './useFeedTypeOptions';

const getFilterOptionIcon = (filterType: FeedType) => {
	switch (filterType) {
		case FeedType.Department:
			return OfficeBuildingOutline({ size: 'sm' });
		case FeedType.Location:
			return GlobeOutline({ size: 'sm' });
		case FeedType.Team:
			return UserGroupOutline({ size: 'sm' });
		default:
			return null;
	}
};

// Transform from SavedFilterOption to FeedTypeOption
export const useTransformSavedFilterOption = () => {
	return (savedFilterOption: SavedFilterOption) => {
		return {
			id: savedFilterOption.id,
			feedType: savedFilterOption.filter_type as FeedType,
			icon: getFilterOptionIcon(savedFilterOption.filter_type as FeedType),
			displayLabel: savedFilterOption.options[0]?.name ?? '',
		};
	};
};
